/* SABERA: FAQ アコーディオンのディープリンク。
   検索結果ページから /pages/faq#faq-<block id> で飛んでくるので、
   その <details> を開いて、固定ヘッダーに隠れない位置まで送る。

   <details> 自身が :target なので、ブラウザの「フラグメント先の details を自動で開く」
   挙動 (対象が details の子孫のときだけ働く) には乗らない。ここで明示的に開く。

   スクロールは load 後に行う。DOMContentLoaded の時点で送っても、そのあとに走る
   ブラウザ標準のアンカージャンプが後勝ちして、対象が固定ヘッダーの下に潜ってしまう。
   慣性スクロール (Lenis) が有効なときは実スクロール位置を Lenis が持っているので、
   window.scrollTo ではなく lenis.scrollTo を使う。 */
(function () {
  'use strict';

  var HEADER_OFFSET = 96; // ヘッダー 7.2rem + 余白

  function getTarget() {
    var hash = window.location.hash;
    if (!hash || hash.length < 2) return null;

    var target;
    try {
      target = document.querySelector(hash);
    } catch (e) {
      // 不正なセレクタになるハッシュ (#1 など) は無視する
      return null;
    }
    return target && target.tagName === 'DETAILS' ? target : null;
  }

  function scrollToTarget(target) {
    var top = target.getBoundingClientRect().top + window.pageYOffset - HEADER_OFFSET;
    var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    if (window.lenis && typeof window.lenis.scrollTo === 'function') {
      window.lenis.scrollTo(top, { immediate: reduced });
    } else {
      window.scrollTo({ top: top, behavior: reduced ? 'auto' : 'smooth' });
    }
  }

  function open(shouldScroll) {
    var target = getTarget();
    if (!target) return;

    target.open = true;
    if (!shouldScroll) return;

    // 開閉のトランジションでレイアウトが動くので、確定してから位置を取り直す
    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        scrollToTarget(target);
      });
    });
  }

  // まず開くだけ。ここで送るとブラウザ標準のアンカージャンプに上書きされる
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      open(false);
    });
  } else {
    open(false);
  }

  // 標準のアンカージャンプが終わってから、ヘッダー分だけ下げた位置に送り直す
  if (document.readyState === 'complete') {
    open(true);
  } else {
    window.addEventListener('load', function () {
      open(true);
    });
  }

  window.addEventListener('hashchange', function () {
    open(true);
  });
})();
